<div class="cx-saved-cart-list-header" *ngIf="savedCart$ | async as savedCart">
  <h2>Carritos guardados: {{ savedCart.length }}</h2>
</div>

<cx-saved-cart-list></cx-saved-cart-list>
